import { uniq } from 'ramda';
import { createAction } from 'redux-actions';

import { replaceData } from '@gef-ui/form-core/stream/transfer/control';

import campaignDetail from 'features/views/campaignManagement/campaignDetail';
import user from 'features/views/user';

import * as types from './actionTypes';
import { CAMPAIGN_REGION_NOMINATIONS_FORM_NAME } from './form';

export const submitFilter = createAction(types.UPDATE_FILTER, (filter) => ({ filter }));
export const resetFilter = createAction(types.RESET_FILTER);

export const initializeOrganizationStructure =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		const campaign = campaignDetail.selectors.getCampaignDetail(getState());
		const roleStructure = user.selectors.getRoleStructure(getState());
		const allowedRegionsByChannelId = user.selectors.getAllowedRegionsByChannel(getState(), campaign?.channelId);
		const uniqedRegions = uniq(allowedRegionsByChannelId);
		const hasOnlyOneRegion = uniqedRegions.length === 1;

		const data = {
			channel: campaign?.channelId,
			region: roleStructure?.regionId,
			agency: roleStructure?.agencyId,
		};

		sendControlNext(CAMPAIGN_REGION_NOMINATIONS_FORM_NAME, replaceData({ data }));
		dispatch(submitFilter({ ...data, region: hasOnlyOneRegion ? uniqedRegions[0] : roleStructure?.regionId }));
	};
